var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split-line",class:_vm.align},[_c('div',{staticClass:"line"}),_c('span',{style:({ 'background-color': _vm.backgroundColor })},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }